import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

interface BackButtonProps {
	to: string;
	label: string;
	className?: string;
	iconClassName?: string;
}

export const BackButton = ({ to, label, className = "text-digger-blue hover:underline flex items-center", iconClassName = "h-4 w-4 mr-1" }: BackButtonProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [canGoBack, setCanGoBack] = useState(false);

	useEffect(() => {
		// Check if we have navigation state or if history length indicates we can go back
		// In an SPA, we need to track if the user navigated within the app
		const hasNavigationState = location.key !== "default";
		setCanGoBack(hasNavigationState && window.history.length > 1);
	}, [location]);

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		// If we can go back within the app, do so
		if (canGoBack)
			navigate(-1);
		else
			navigate(to);
	};

	return (
		<a href={to} onClick={handleClick} className={className}>
			<ArrowLeft className={iconClassName} />
			{label}
		</a>
	);
};
